
{
  "familyId": "GET-BREUK-DEEL",
  "questions": [
    {
      "id": "GET-BREUK-DEEL-001",
      "familyId": "GET-BREUK-DEEL",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "skill": "breuken",
      "subSkill": "breuk_delen",
      "questionType": "multiple_choice",
      "question": "Bereken: $\\frac{3}{4} \\div \\frac{2}{3}$",
      "options": ["$\\frac{9}{8}$", "$\\frac{6}{12}$", "$\\frac{6}{4}$", "$\\frac{3}{8}$"],
      "correctAnswer": 0,
      "conceptId": "divide_fractions_basic",
      "variantIndex": 1,
      "group": 8,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.72,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 3,
            "denominator": 4,
            "label": "$\\frac{3}{4} \\div \\frac{2}{3}$ — draai de tweede breuk om en vermenigvuldig",
            "visualType": "bar",
            "showEaten": false
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Breuken delen",
            "content": "Delen door een breuk = keer het omgekeerde. Draai de tweede breuk om en vermenigvuldig. ¾ ÷ ⅔ = ¾ × ³⁄₂ = 9/8.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Delen door een breuk = keer het omgekeerde. Stap 1: draai $\\frac{2}{3}$ om → $\\frac{3}{2}$. Stap 2: vermenigvuldig: $\\frac{3}{4} \\times \\frac{3}{2}$ = $\\frac{3 \\times 3}{4 \\times 2}$ = $\\frac{9}{8}$. Controleer: $\\frac{9}{8} \\times \\frac{2}{3}$ = $\\frac{18}{24}$ = $\\frac{3}{4}$ ✓.",
        "solutionSteps": [
          "Delen door een breuk = keer het omgekeerde",
          "Draai $\\frac{2}{3}$ om → $\\frac{3}{2}$",
          "Vermenigvuldig: $\\frac{3}{4} \\times \\frac{3}{2}$",
          "Teller: 3 × 3 = 9, noemer: 4 × 2 = 8",
          "Antwoord: $\\frac{9}{8}$"
        ],
        "distractorExplanations": {
          "0": "Goed! $\\frac{3}{4} \\times \\frac{3}{2}$ = $\\frac{9}{8}$. Teller: 3×3=9, noemer: 4×2=8.",
          "1": "Je hebt de breuken vermenigvuldigd zonder om te draaien: $\\frac{3}{4} \\times \\frac{2}{3}$ = $\\frac{6}{12}$. Maar je moet eerst de tweede breuk omdraaien. Onthoud: delen = keer het omgekeerde.",
          "2": "Je hebt de eerste breuk met de teller van de tweede vermenigvuldigd maar de noemer vergeten om te draaien. $\\frac{3 \\times 2}{4}$ = $\\frac{6}{4}$. Onthoud: draai de hele tweede breuk om, niet alleen de teller.",
          "3": "Je hebt de tellers vermenigvuldigd maar de noemers opgeteld (4+4=8). De noemer is 4×2=8, maar de teller moet 3×3=9 zijn, niet 3×1=3. Onthoud: draai de tweede breuk om vóór je vermenigvuldigt."
        }
      }
    },
    {
      "id": "GET-BREUK-DEEL-002",
      "familyId": "GET-BREUK-DEEL",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "skill": "breuken",
      "subSkill": "breuk_delen",
      "questionType": "multiple_choice",
      "question": "Bereken: $\\frac{1}{2} \\div \\frac{1}{4}$",
      "options": ["2", "$\\frac{1}{8}$", "$\\frac{2}{4}$", "4"],
      "correctAnswer": 0,
      "conceptId": "divide_fractions_simple",
      "variantIndex": 2,
      "group": 8,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.75,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 1,
            "denominator": 2,
            "label": "Hoeveel keer past $\\frac{1}{4}$ in $\\frac{1}{2}$?",
            "visualType": "bar",
            "showEaten": false
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Breuken delen — omdraaien",
            "content": "Draai ¼ om → ⁴⁄₁ = 4. Dan: ½ × 4 = ⁴⁄₂ = 2. Er passen 2 kwarten in een half.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Delen door een breuk = keer het omgekeerde. Draai $\\frac{1}{4}$ om → $\\frac{4}{1}$ = 4. Vermenigvuldig: $\\frac{1}{2} \\times 4$ = $\\frac{4}{2}$ = 2. Er passen precies 2 kwarten in een half.",
        "solutionSteps": [
          "Draai $\\frac{1}{4}$ om → $\\frac{4}{1}$ = 4",
          "Vermenigvuldig: $\\frac{1}{2} \\times 4$ = $\\frac{4}{2}$",
          "Vereenvoudig: $\\frac{4}{2}$ = 2",
          "Antwoord: 2"
        ],
        "distractorExplanations": {
          "0": "Goed! $\\frac{1}{2} \\times \\frac{4}{1}$ = $\\frac{4}{2}$ = 2.",
          "1": "Je hebt vermenigvuldigd in plaats van gedeeld: $\\frac{1}{2} \\times \\frac{1}{4}$ = $\\frac{1}{8}$. Maar de vraag is delen, niet vermenigvuldigen. Onthoud: bij delen draai je de tweede breuk om.",
          "2": "Je hebt de tellers en noemers apart gedeeld. Dat werkt niet bij breuken delen. Gebruik het omgekeerde: $\\frac{1}{2} \\times \\frac{4}{1}$ = 2.",
          "3": "4 is het omgekeerde van $\\frac{1}{4}$, maar je moet dit nog vermenigvuldigen met $\\frac{1}{2}$: $\\frac{1}{2} \\times 4$ = 2, niet 4. Onthoud: het omdraaien is stap 1, vermenigvuldigen is stap 2."
        }
      }
    },
    {
      "id": "GET-BREUK-DEEL-003",
      "familyId": "GET-BREUK-DEEL",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "skill": "breuken",
      "subSkill": "breuk_delen",
      "questionType": "multiple_choice",
      "question": "Sophie heeft $\\frac{3}{4}$ liter sap. Ze verdeelt dit in bekertjes van $\\frac{1}{8}$ liter. Hoeveel bekertjes kan ze vullen?",
      "options": ["6", "8", "3", "4"],
      "correctAnswer": 0,
      "conceptId": "divide_fractions_context",
      "variantIndex": 3,
      "group": 8,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.70,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 3,
            "denominator": 4,
            "label": "$\\frac{3}{4}$ liter verdeeld in bekertjes van $\\frac{1}{8}$ liter",
            "visualType": "bar",
            "showEaten": false
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verdelen in gelijke stukken",
            "content": "Verdelen = delen. ¾ ÷ ⅛ = ¾ × ⁸⁄₁ = ²⁴⁄₄ = 6 bekertjes.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Hoeveel bekertjes van $\\frac{1}{8}$ passen in $\\frac{3}{4}$? Dat is delen: $\\frac{3}{4} \\div \\frac{1}{8}$. Draai $\\frac{1}{8}$ om → $\\frac{8}{1}$ = 8. Vermenigvuldig: $\\frac{3}{4} \\times 8$ = $\\frac{24}{4}$ = 6. Sophie kan 6 bekertjes vullen.",
        "solutionSteps": [
          "Dit is een deelsom: $\\frac{3}{4} \\div \\frac{1}{8}$",
          "Draai $\\frac{1}{8}$ om → $\\frac{8}{1}$ = 8",
          "Vermenigvuldig: $\\frac{3}{4} \\times 8$ = $\\frac{24}{4}$",
          "Vereenvoudig: $\\frac{24}{4}$ = 6",
          "Sophie kan 6 bekertjes vullen"
        ],
        "distractorExplanations": {
          "0": "Goed! $\\frac{3}{4} \\times 8$ = $\\frac{24}{4}$ = 6 bekertjes.",
          "1": "8 is de noemer van het bekertje ($\\frac{1}{8}$), niet het aantal bekertjes. Je moet $\\frac{3}{4} \\div \\frac{1}{8}$ uitrekenen: $\\frac{3}{4} \\times 8$ = 6. Onthoud: de noemer is niet automatisch het antwoord.",
          "2": "3 is de teller van $\\frac{3}{4}$. Je hebt het omdraaien overgeslagen. $\\frac{3}{4} \\times \\frac{8}{1}$ = $\\frac{24}{4}$ = 6, niet 3. Onthoud: draai de tweede breuk om en vermenigvuldig.",
          "3": "4 is de noemer van $\\frac{3}{4}$. Vergeet niet het omgekeerde te nemen: $\\frac{1}{8}$ wordt $\\frac{8}{1}$. Dan: $\\frac{3}{4} \\times 8$ = 6. Onthoud: de noemer van de eerste breuk is niet het antwoord."
        }
      }
    },
    {
      "id": "GET-BREUK-DEEL-004",
      "familyId": "GET-BREUK-DEEL",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "skill": "breuken",
      "subSkill": "breuk_delen",
      "questionType": "multiple_choice",
      "question": "Bereken: $\\frac{5}{6} \\div \\frac{5}{12}$",
      "options": ["2", "$\\frac{25}{72}$", "$\\frac{1}{2}$", "$\\frac{10}{6}$"],
      "correctAnswer": 0,
      "conceptId": "divide_fractions_simplify",
      "variantIndex": 4,
      "group": 8,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.71,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Delen en vereenvoudigen",
            "content": "Draai ⁵⁄₁₂ om → ¹²⁄₅. Dan: ⁵⁄₆ × ¹²⁄₅ = ⁶⁰⁄₃₀ = 2. Tip: je kunt ook eerst wegstrepen: de 5 in teller en noemer valt weg.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Draai $\\frac{5}{12}$ om → $\\frac{12}{5}$. Vermenigvuldig: $\\frac{5}{6} \\times \\frac{12}{5}$ = $\\frac{60}{30}$ = 2. Tip: je kunt eerst vereenvoudigen — de 5 in teller en noemer valt weg: $\\frac{\\cancel{5}}{6} \\times \\frac{12}{\\cancel{5}}$ = $\\frac{12}{6}$ = 2.",
        "solutionSteps": [
          "Draai $\\frac{5}{12}$ om → $\\frac{12}{5}$",
          "Vermenigvuldig: $\\frac{5}{6} \\times \\frac{12}{5}$",
          "Vereenvoudig: 5 in teller en noemer valt weg → $\\frac{12}{6}$",
          "Antwoord: $\\frac{12}{6}$ = 2"
        ],
        "distractorExplanations": {
          "0": "Goed! $\\frac{5}{6} \\times \\frac{12}{5}$ = $\\frac{60}{30}$ = 2.",
          "1": "Je hebt vermenigvuldigd zonder om te draaien: $\\frac{5}{6} \\times \\frac{5}{12}$ = $\\frac{25}{72}$. Maar bij delen moet je de tweede breuk omdraaien. Onthoud: delen = keer het omgekeerde.",
          "2": "Je hebt het antwoord omgedraaid. $\\frac{5}{6} \\div \\frac{5}{12}$ = 2, niet $\\frac{1}{2}$. Controleer: 2 × $\\frac{5}{12}$ = $\\frac{10}{12}$ = $\\frac{5}{6}$ ✓.",
          "3": "Je hebt alleen de tellers vermenigvuldigd (5×2=10) maar de noemer niet aangepast. De volledige berekening is: $\\frac{5}{6} \\times \\frac{12}{5}$ = $\\frac{60}{30}$ = 2."
        }
      }
    },
    {
      "id": "GET-BREUK-DEEL-005",
      "familyId": "GET-BREUK-DEEL",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "skill": "breuken",
      "subSkill": "breuk_delen",
      "questionType": "multiple_choice",
      "question": "Een schilder heeft $\\frac{2}{3}$ liter verf. Elke muur kost $\\frac{1}{6}$ liter. Hoeveel muren kan hij verven?",
      "options": ["4", "3", "6", "$\\frac{2}{18}$"],
      "correctAnswer": 0,
      "conceptId": "divide_fractions_context_walls",
      "variantIndex": 5,
      "group": 8,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.72,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verdelen in porties",
            "content": "Hoeveel keer past ⅙ in ⅔? Dat is ⅔ ÷ ⅙ = ⅔ × ⁶⁄₁ = ¹²⁄₃ = 4 muren.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Hoeveel keer past $\\frac{1}{6}$ in $\\frac{2}{3}$? Dat is delen: $\\frac{2}{3} \\div \\frac{1}{6}$. Draai $\\frac{1}{6}$ om → $\\frac{6}{1}$ = 6. Vermenigvuldig: $\\frac{2}{3} \\times 6$ = $\\frac{12}{3}$ = 4. De schilder kan 4 muren verven.",
        "solutionSteps": [
          "Dit is een deelsom: $\\frac{2}{3} \\div \\frac{1}{6}$",
          "Draai $\\frac{1}{6}$ om → $\\frac{6}{1}$ = 6",
          "Vermenigvuldig: $\\frac{2}{3} \\times 6$ = $\\frac{12}{3}$",
          "Vereenvoudig: $\\frac{12}{3}$ = 4",
          "De schilder kan 4 muren verven"
        ],
        "distractorExplanations": {
          "0": "Goed! $\\frac{2}{3} \\times 6$ = $\\frac{12}{3}$ = 4 muren.",
          "1": "Je hebt waarschijnlijk $\\frac{2}{3} \\div \\frac{2}{6}$ berekend of een tussenstap overgeslagen. $\\frac{2}{3} \\times 6$ = $\\frac{12}{3}$ = 4, niet 3. Onthoud: reken de hele berekening uit.",
          "2": "6 is het omgekeerde van $\\frac{1}{6}$, maar je moet dit nog vermenigvuldigen met $\\frac{2}{3}$: $\\frac{2}{3} \\times 6$ = 4, niet 6. Onthoud: omdraaien is stap 1, vermenigvuldigen is stap 2.",
          "3": "Je hebt de breuken vermenigvuldigd zonder om te draaien: $\\frac{2}{3} \\times \\frac{1}{6}$ = $\\frac{2}{18}$. Maar bij delen moet je de tweede breuk omdraaien. Onthoud: delen = keer het omgekeerde."
        }
      }
    }
  ]
}
